export default __webpack_public_path__ + "static/media/boyIcon.fc2388c2.svg";